export const HELP_PAGE_TOP_ID = "help-page-top";

/** Scroll the help shell to the top so the user can reach the help navigator. */
export function scrollToHelpTop() {
  const top = document.getElementById(HELP_PAGE_TOP_ID);
  if (top) {
    top.scrollIntoView({ behavior: "smooth", block: "start" });
    return true;
  }
  window.scrollTo({ top: 0, behavior: "smooth" });
  return false;
}
